module.exports = function() {
	$('form.guest').submit(function(e) {
		const form = $(this);
		e.preventDefault();
		const url = form.attr('action');
		window.location.href = `${url}?${form.serialize()}`;
	});
};
